<profile-applet-profile-menu-group
  [items]="guides"
  (onAction)="goToGuidePage($event)"
></profile-applet-profile-menu-group>
